import React, { useState, useEffect } from 'react';
import { Card, Form, InputNumber, Button, message, Space, Typography } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import api from '../../utils/axios';

const { Title, Text } = Typography;

const PublicSeaSettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // 获取当前设置
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await api.get('/settings/public-sea');
      if (response.data) {
        form.setFieldsValue({
          autoReleaseDays: response.data.auto_release_days || 15
        });
      }
    } catch (error) {
      console.error('获取公海设置失败:', error);
      message.error('获取公海设置失败');
    } finally {
      setLoading(false);
    }
  };

  // 保存设置
  const handleSave = async (values) => {
    setSaving(true);
    try {
      await api.post('/settings/public-sea', {
        auto_release_days: values.autoReleaseDays
      });
      message.success('公海设置保存成功');
    } catch (error) {
      console.error('保存公海设置失败:', error);
      message.error('保存公海设置失败');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <Card>
      <div style={{ marginBottom: 24 }}>
        <Title level={3}>公海线索管理</Title>
        <Text type="secondary">
          配置线索自动丢弃到公海的规则和参数
        </Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        initialValues={{
          autoReleaseDays: 15
        }}
      >
        <Form.Item
          label="自动丢弃天数"
          name="autoReleaseDays"
          rules={[
            { required: true, message: '请输入自动丢弃天数' },
            { type: 'number', min: 1, max: 365, message: '天数必须在1-365之间' }
          ]}
          extra="设置多少天没有跟进联系后，线索自动丢弃到公海中"
        >
          <InputNumber
            min={1}
            max={365}
            style={{ width: 200 }}
            addonAfter="天"
            placeholder="请输入天数"
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              htmlType="submit"
              loading={saving}
            >
              保存设置
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchSettings}
              loading={loading}
            >
              刷新
            </Button>
          </Space>
        </Form.Item>
      </Form>

      <Card size="small" style={{ marginTop: 24 }}>
        <Title level={4}>说明</Title>
        <ul>
          <li>当线索在指定天数内没有跟进记录时，系统会自动将其状态改为"公海"</li>
          <li>其他用户可以从公海中领取这些线索</li>
          <li>您也可以手动将线索丢弃到公海中</li>
          <li>建议根据业务需求设置合适的天数，避免线索资源浪费</li>
        </ul>
      </Card>
    </Card>
  );
};

export default PublicSeaSettings; 